<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app'
	}
</script>

<style lang="scss">
	@import './scss/_variables.scss';

	body {
		text-rendering: optimizeLegibility;
		background-color: palette(white);
		margin: 0;
	}

	#app {
		width: 100vw;
		font: {
			family: $sans-serif;
			size: 0.9rem;
		}
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.text-center {
  	text-align: center;
	}

	@font-face {
		font-family: "Adobe Caslon Pro";
		src: url('assets/font/adobe_caslon_pro.woff') format('woff');
	}

	@font-face {
		font-family: "Aktiv Grotesk Corp";
		src: url('assets/font/aktivgrotesk-corp-regular.woff') format('woff');
	}

	@font-face {
		font-family: "Aktiv Grotesk Corp Bold";
		src: url('assets/font/aktivgrotesk-corp-bold.woff') format('woff');
	}

</style>


// WEBPACK FOOTER //
// App.vue?43b92bbe